import { render, staticRenderFns } from "./landlordDetail.vue?vue&type=template&id=9272532c&scoped=true&"
import script from "./landlordDetail.vue?vue&type=script&lang=js&"
export * from "./landlordDetail.vue?vue&type=script&lang=js&"
import style0 from "./landlordDetail.vue?vue&type=style&index=0&id=9272532c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9272532c",
  null
  
)

export default component.exports